import webinarContext from "./webinarContext";

const webinarState = (props) => {
  const webinars = [
    {
      id: "web1",
      featimage: "web1",
      realtedImage: "web1_2",
      bannerimage: "web1_wide",
      heading: "4th Spandan-Aravali Prof. Ishwar Dayal Memorial Lecture",
      featuring: "By Padma Bhushan Awardee,",
      guest: "Dr. Mallika Sarabhai",
      past: "(Actress, Director, Producer, Choreographer, Dancer, and Social Activist)",
      host: "*  Prof. Ishwar Dayal was part of the initial faculty of IIM Calcutta & IIM Ahmedabad after these were set up in the year 1961 and Founding Director of IIM Lucknow when it was established in the year 1984. He was Chairman, Advisory Council, Spandan Foundation for Human Values, from its inception in the year 2001 till his passing away on 24 March 2015.",
      date: "26th June 2022, Sunday,",
      time: "11:00 AM IST",
      link: "https://us06web.zoom.us/j/83803070549",
      video: "https://www.youtube.com/embed/Ag78Lm08iv8",
      done: true,
    },
    {
      id: "web2",
      featimage: "web2",
      realtedImage: "web2_2",
      bannerimage: "web2_wide",
      heading: "1st Spandan-Aravali Shri Satish Bagrodia Memorial Lecture",
      featuring: "By Padma Vibhushan Awardee",
      guest: "Dr. Montek Singh Ahluwalia",
      past: "(Eminent Economist & Former Deputy Chairman, Planning Commission of India)",
      host: "*  Shri Satish Bagrodia was a pioneer industrialist and philanthropist of our country. He was the Chairman of IDS Infotech Ltd. and Winsome Textile Industries Ltd., Vice Chairman of Winsome Yarns Ltd. and Managing Trustee of the Winsome Foundation. His long and distinguished career was full of many accomplishments and successes and served as an example of great entrepreneurship and management abilities.",
      date: "3rd July 2022, Sunday,",
      time: "11:00 AM IST",
      link: "https://us06web.zoom.us/j/84810802093",
      video: "https://www.youtube.com/embed/mrC2A43qtig",
      done: true,
    },
    {
      id: "web3",
      featimage: "web3",
      realtedImage: "web3_2",
      bannerimage: "web3_wide",
      heading: "1st Spandan-Aravali  Prof. G.P. Rao Memorial Lecture",
      featuring: "By Magsaysay Awardee",
      guest: "Dr. Kiran Bedi",
      past: "(India’s First Lady IPS Officer, Former Lt. Governor of Puducherry and Social Activist)",
      host: "*  Prof. G. P. Rao was a post-graduate of the first batch of IIM Calcutta. He had been involved in teaching, research, training and consultancy in management since 1966 at IIM Calcutta, Panjab University Chandigarh and Madurai Kamaraj University Madurai. He had founded Spandan Foundation for Human Values in Management & Society in the year 2001.",
      date: "9th July 2022, Saturday,",
      time: "05:00 PM IST",
      link: "https://us06web.zoom.us/j/87902339657",
      video: "https://www.youtube.com/embed/3WNhyToSXws",
      done: true,
    },
  ];

  return (
    <webinarContext.Provider value={{ webinars }}>
      {props.children}
    </webinarContext.Provider>
  );
};

export default webinarState;
